import { Injectable } from '@angular/core';
import { AppInsightPartSearch } from 'entities/app-insight-part-search';
import { CommonDataService } from './common-data.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {

  constructor(
    private readonly loggerService: LoggerService,
    private readonly commonDataService: CommonDataService,
  ) {}

  public trackPartSearch(parts: any, searchTerm: string, source: string) {
    const metricName = 'PartsComponent_getParts_getParts';
    const appInsightPartSearch = Object.assign(new AppInsightPartSearch(), {
      userId: this.commonDataService.User.id,
      searchTerm,
      rewardNumber: this.commonDataService.Customer.rewardNumber,
      branchNumber: this.commonDataService.Branch.code,
      cartDetails: JSON.stringify(this.commonDataService.CartDetails),
      source,
      plMetricName: metricName
    });
    appInsightPartSearch.results = this.loggerService.getAppInsightParts(parts, JSON.stringify(appInsightPartSearch).length);
    this.loggerService.trackMetric(metricName, appInsightPartSearch);
  }
}